var map = {
	"./asia": 721,
	"./asia.js": 721,
	"./australia": 723,
	"./australia.js": 723,
	"./cricinfo/africa": 622,
	"./cricinfo/africa.js": 622,
	"./cricinfo/australia": 711,
	"./cricinfo/australia.js": 711,
	"./cricinfo/bangladesh": 712,
	"./cricinfo/bangladesh.js": 712,
	"./cricinfo/global": 713,
	"./cricinfo/global.js": 713,
	"./cricinfo/india": 714,
	"./cricinfo/india.js": 714,
	"./cricinfo/newzealand": 715,
	"./cricinfo/newzealand.js": 715,
	"./cricinfo/pakistan": 716,
	"./cricinfo/pakistan.js": 716,
	"./cricinfo/srilanka": 717,
	"./cricinfo/srilanka.js": 717,
	"./cricinfo/taboola": 709,
	"./cricinfo/taboola.js": 709,
	"./cricinfo/unitedkingdom": 718,
	"./cricinfo/unitedkingdom.js": 718,
	"./cricinfo/unitedstates": 719,
	"./cricinfo/unitedstates.js": 719,
	"./en-global": 724,
	"./en-global.js": 724,
	"./india": 725,
	"./india.js": 725,
	"./philippines": 726,
	"./philippines.js": 726,
	"./portuguese/brazil": 727,
	"./portuguese/brazil.js": 727,
	"./southafrica": 729,
	"./southafrica.js": 729,
	"./spanish/argentina": 730,
	"./spanish/argentina.js": 730,
	"./spanish/chile": 731,
	"./spanish/chile.js": 731,
	"./spanish/colombia": 732,
	"./spanish/colombia.js": 732,
	"./spanish/dominicanrepublic": 733,
	"./spanish/dominicanrepublic.js": 733,
	"./spanish/ecuador": 734,
	"./spanish/ecuador.js": 734,
	"./spanish/guatemala": 735,
	"./spanish/guatemala.js": 735,
	"./spanish/mexico": 736,
	"./spanish/mexico.js": 736,
	"./spanish/panama": 737,
	"./spanish/panama.js": 737,
	"./spanish/peru": 738,
	"./spanish/peru.js": 738,
	"./spanish/spain": 739,
	"./spanish/spain.js": 739,
	"./spanish/unitedstates": 740,
	"./spanish/unitedstates.js": 740,
	"./spanish/uruguay": 741,
	"./spanish/uruguay.js": 741,
	"./spanish/venezuela": 742,
	"./spanish/venezuela.js": 742,
	"./taboola": 722,
	"./taboola.js": 722,
	"./taboolaDefaults": 710,
	"./taboolaDefaults.js": 710,
	"./unitedkingdom": 743,
	"./unitedkingdom.js": 743,
	"./unitedstates": 744,
	"./unitedstates.js": 744
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 720;



//////////////////
// WEBPACK FOOTER
// ../app/lib/utils/editions/config ^\.\/.*$
// module id = 720
// module chunks = 0